{
  "familyId": "GET-KOMMA-VERGELIJK",
  "questions": [
    {
      "id": "GET-KOMMA-VERGELIJK-001",
      "familyId": "GET-KOMMA-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_vergelijken",
      "questionType": "multiple_choice",
      "question": "Welk getal is het grootst: 0,8 of 0,53?",
      "context": null,
      "options": ["0,8", "0,53", "ze zijn gelijk", "dat kun je niet vergelijken"],
      "correctAnswer": 0,
      "stimulusAids": [
        { "type": "numberline", "data": { "start": 0, "end": 1, "marked": [0.53, 0.8], "step": 0.1, "label": "0,53 en 0,80 op de getallenlijn" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Kommagetallen vergelijken", "content": "Maak het aantal cijfers achter de komma gelijk door een nul toe te voegen. 0,8 = 0,80. Vergelijk nu: 80 honderdsten > 53 honderdsten. Dus 0,8 is groter.", "icon": "lightbulb" } }
      ],
      "conceptId": "komma_vergelijk_tienden_honderdsten",
      "variantIndex": 1,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Maak het aantal cijfers achter de komma gelijk: 0,8 = 0,80. Vergelijk nu: 0,80 en 0,53. 80 honderdsten is meer dan 53 honderdsten. Dus 0,8 > 0,53.",
        "solutionSteps": ["Maak het aantal cijfers gelijk: 0,8 = 0,80", "Vergelijk: 80 honderdsten en 53 honderdsten", "80 > 53, dus 0,8 > 0,53", "0,8 is het grootst"],
        "distractorExplanations": {
          "0": "Goed! 0,8 = 0,80 = 80 honderdsten. Dat is meer dan 0,53 = 53 honderdsten.",
          "1": "Je dacht waarschijnlijk dat meer cijfers achter de komma een groter getal betekent. Maar 0,53 = 53 honderdsten en 0,8 = 80 honderdsten. 80 > 53. Onthoud: voeg eerst een nul toe zodat je eerlijk vergelijkt.",
          "2": "Je dacht waarschijnlijk dat de getallen gelijk zijn. Maar 0,8 = 80 honderdsten en 0,53 = 53 honderdsten. 80 ≠ 53. Onthoud: maak het aantal cijfers achter de komma gelijk om te vergelijken.",
          "3": "Je dacht waarschijnlijk dat je kommagetallen niet kunt vergelijken. Maar dat kan wel: voeg nullen toe zodat beide getallen evenveel cijfers achter de komma hebben, en vergelijk dan. Onthoud: kommagetallen kun je altijd vergelijken."
        }
      }
    },
    {
      "id": "GET-KOMMA-VERGELIJK-002",
      "familyId": "GET-KOMMA-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_vergelijken",
      "questionType": "multiple_choice",
      "question": "Zet in de juiste volgorde van klein naar groot: 1,5 — 1,05 — 1,50",
      "context": null,
      "options": ["1,05 — 1,5 — 1,50", "1,5 — 1,05 — 1,50", "1,50 — 1,05 — 1,5", "1,50 — 1,5 — 1,05"],
      "correctAnswer": 0,
      "stimulusAids": [
        { "type": "numberline", "data": { "start": 1, "end": 1.6, "marked": [1.05, 1.5], "step": 0.1, "label": "1,05 en 1,50 op de getallenlijn" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Gelijke nullen achter de komma", "content": "1,5 en 1,50 zijn precies gelijk — de extra nul verandert de waarde niet. 1,05 = 5 honderdsten, 1,50 = 50 honderdsten. 5 < 50, dus 1,05 is het kleinst.", "icon": "lightbulb" } }
      ],
      "conceptId": "komma_ordenen_gelijk",
      "variantIndex": 2,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Maak alle getallen even lang achter de komma: 1,5 = 1,50 en 1,05 = 1,05. Vergelijk: 1,05 heeft 5 honderdsten, 1,50 heeft 50 honderdsten. 1,05 is het kleinst. Let op: 1,5 en 1,50 zijn precies gelijk — de extra nul verandert de waarde niet. Volgorde: 1,05 — 1,5 — 1,50.",
        "solutionSteps": ["Maak gelijk: 1,5 = 1,50 en 1,05 = 1,05", "Vergelijk honderdsten: 05, 50, 50", "1,05 (5 honderdsten) is het kleinst", "1,5 en 1,50 zijn gelijk (allebei 50 honderdsten)", "Volgorde: 1,05 — 1,5 — 1,50"],
        "distractorExplanations": {
          "0": "Goed! 1,05 (5 honderdsten) is het kleinst. 1,5 en 1,50 zijn gelijk (allebei 50 honderdsten).",
          "1": "Je dacht waarschijnlijk dat 1,5 kleiner is dan 1,05 omdat 5 kleiner lijkt dan 05. Maar maak het gelijk: 1,5 = 1,50 = 50 honderdsten, en 1,05 = 5 honderdsten. 50 > 5. Onthoud: voeg eerst een nul toe zodat je eerlijk vergelijkt.",
          "2": "Je dacht waarschijnlijk dat 1,50 het kleinste getal is. Maar 1,50 = 1,5 — ze zijn gelijk. Het kleinste getal is 1,05. Onthoud: een extra nul achter de komma verandert de waarde niet.",
          "3": "Je dacht waarschijnlijk dat dit de volgorde van groot naar klein is. Maar de vraag vraagt van klein naar groot. Begin bij het kleinste getal: 1,05. Onthoud: lees goed of er 'klein naar groot' of 'groot naar klein' staat."
        }
      }
    },
    {
      "id": "GET-KOMMA-VERGELIJK-003",
      "familyId": "GET-KOMMA-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_vergelijken",
      "questionType": "multiple_choice",
      "question": "Welk teken hoort er: 2,45 ○ 2,5?",
      "context": null,
      "options": ["<", ">", "=", "≠"],
      "correctAnswer": 0,
      "stimulusAids": [
        { "type": "numberline", "data": { "start": 2.4, "end": 2.6, "marked": [2.45, 2.5], "step": 0.05, "label": "2,45 en 2,50 op de getallenlijn" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Vergelijkingstekens bij kommagetallen", "content": "Maak het aantal cijfers gelijk: 2,45 en 2,50. 45 honderdsten < 50 honderdsten. Dus 2,45 < 2,50. Het teken < wijst naar het kleinste getal.", "icon": "lightbulb" } }
      ],
      "conceptId": "komma_vergelijk_teken",
      "variantIndex": 3,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Maak het aantal cijfers achter de komma gelijk: 2,45 blijft 2,45 en 2,5 = 2,50. Vergelijk: 45 honderdsten < 50 honderdsten. Dus 2,45 < 2,50 → het teken is <.",
        "solutionSteps": ["Maak gelijk: 2,5 = 2,50", "Vergelijk: 2,45 en 2,50", "45 honderdsten < 50 honderdsten", "Dus 2,45 < 2,5 → teken is <"],
        "distractorExplanations": {
          "0": "Goed! 2,45 < 2,50 (= 2,5). 45 honderdsten is minder dan 50 honderdsten.",
          "1": "Je dacht waarschijnlijk dat 2,45 > 2,5 omdat 45 > 5. Maar je moet het aantal cijfers gelijk maken: 2,45 vs 2,50. Dan zie je: 45 < 50. Onthoud: voeg eerst een nul toe, dan vergelijk je eerlijk.",
          "2": "Je dacht waarschijnlijk dat de getallen gelijk zijn. Maar 2,45 = 245 honderdsten en 2,5 = 250 honderdsten. 245 ≠ 250. Onthoud: maak het aantal cijfers gelijk om te vergelijken.",
          "3": "Je dacht waarschijnlijk dat ≠ het juiste teken is. Het klopt dat de getallen niet gelijk zijn, maar de vraag vraagt naar het meest precieze teken. < geeft de exacte relatie aan: 2,45 is kleiner dan 2,5. Onthoud: gebruik < of > als je de richting kunt bepalen."
        }
      }
    },
    {
      "id": "GET-KOMMA-VERGELIJK-004",
      "familyId": "GET-KOMMA-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_vergelijken",
      "questionType": "multiple_choice",
      "question": "Welk getal ligt het dichtst bij 3?",
      "context": null,
      "options": ["2,95", "3,1", "2,8", "3,15"],
      "correctAnswer": 0,
      "stimulusAids": [
        { "type": "numberline", "data": { "start": 2.7, "end": 3.2, "marked": [2.8, 2.95, 3, 3.1, 3.15], "step": 0.05, "label": "Alle getallen op de getallenlijn rond 3" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Afstand tot een getal berekenen", "content": "Bereken het verschil met 3 voor elk getal. Het getal met het kleinste verschil ligt het dichtst bij 3. 3 − 2,95 = 0,05 — dat is het kleinst!", "icon": "lightbulb" } }
      ],
      "conceptId": "komma_dichtst_bij",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.69,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Bereken het verschil met 3 voor elk getal. 3 − 2,95 = 0,05. 3,1 − 3 = 0,1. 3 − 2,8 = 0,2. 3,15 − 3 = 0,15. Het kleinste verschil is 0,05, dus 2,95 ligt het dichtst bij 3.",
        "solutionSteps": ["Verschil 2,95: 3 − 2,95 = 0,05", "Verschil 3,1: 3,1 − 3 = 0,1", "Verschil 2,8: 3 − 2,8 = 0,2", "Verschil 3,15: 3,15 − 3 = 0,15", "Kleinste verschil: 0,05 → 2,95 ligt het dichtst bij 3"],
        "distractorExplanations": {
          "0": "Goed! 2,95 verschilt maar 0,05 van 3. Dat is het kleinste verschil van alle opties.",
          "1": "Je dacht waarschijnlijk dat 3,1 het dichtst bij 3 ligt omdat het boven 3 zit. Maar 3,1 verschilt 0,1 van 3, terwijl 2,95 maar 0,05 verschilt. Onthoud: het maakt niet uit of een getal boven of onder 3 ligt — het verschil telt.",
          "2": "Je dacht waarschijnlijk dat 2,8 dicht bij 3 ligt. Maar 2,8 verschilt 0,2 van 3 — dat is veel meer dan 0,05 (het verschil van 2,95). Onthoud: bereken het verschil om te vergelijken.",
          "3": "Je dacht waarschijnlijk dat 3,15 het dichtst bij 3 ligt. Maar 3,15 verschilt 0,15 van 3, terwijl 2,95 maar 0,05 verschilt. Onthoud: bereken het verschil voor elk getal en kies het kleinste."
        }
      }
    },
    {
      "id": "GET-KOMMA-VERGELIJK-005",
      "familyId": "GET-KOMMA-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_vergelijken",
      "questionType": "multiple_choice",
      "question": "Welk getal is het kleinst: 0,4 — 0,09 — 0,41 — 0,1?",
      "context": null,
      "options": ["0,09", "0,1", "0,4", "0,41"],
      "correctAnswer": 0,
      "stimulusAids": [
        { "type": "numberline", "data": { "start": 0, "end": 0.5, "marked": [0.09, 0.1, 0.4, 0.41], "step": 0.1, "label": "Alle getallen op de getallenlijn" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Vergelijken met nullen", "content": "Maak alle getallen even lang: 0,40 — 0,09 — 0,41 — 0,10. Vergelijk de honderdsten: 40, 09, 41, 10. Het kleinste is 09 = 0,09.", "icon": "lightbulb" } }
      ],
      "conceptId": "komma_kleinste_vinden",
      "variantIndex": 5,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.71,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Maak alle getallen even lang achter de komma: 0,40 — 0,09 — 0,41 — 0,10. Vergelijk de honderdsten: 40, 09, 41, 10. Het kleinste getal is 09 honderdsten = 0,09.",
        "solutionSteps": ["Maak gelijk: 0,4 = 0,40; 0,09 = 0,09; 0,41 = 0,41; 0,1 = 0,10", "Vergelijk honderdsten: 40, 09, 41, 10", "Het kleinste is 09 honderdsten", "Dus 0,09 is het kleinste getal"],
        "distractorExplanations": {
          "0": "Goed! 0,09 = 9 honderdsten. Dat is kleiner dan 0,10 (10), 0,40 (40) en 0,41 (41 honderdsten).",
          "1": "Je dacht waarschijnlijk dat 0,1 kleiner is dan 0,09 omdat 1 < 9. Maar maak het gelijk: 0,10 = 10 honderdsten en 0,09 = 9 honderdsten. 10 > 9. Onthoud: voeg eerst een nul toe, dan vergelijk je eerlijk.",
          "2": "Je dacht waarschijnlijk dat 0,4 het kleinst is. Maar 0,4 = 0,40 = 40 honderdsten — dat is veel groter dan 0,09 = 9 honderdsten. Onthoud: maak het aantal cijfers gelijk om te vergelijken.",
          "3": "Je dacht waarschijnlijk dat 0,41 het kleinst is. Maar 0,41 = 41 honderdsten — dat is het grootste getal in de reeks. Onthoud: meer honderdsten = groter getal."
        }
      }
    },
    {
      "id": "GET-KOMMA-VERGELIJK-006",
      "familyId": "GET-KOMMA-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_vergelijken",
      "questionType": "ordering",
      "question": "Zet deze kommagetallen van klein naar groot.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["0,7", "0,07", "0,71", "0,17"],
        "correctOrder": [1, 3, 0, 2]
      },
      "stimulusAids": [
        { "type": "numberline", "data": { "start": 0, "end": 0.8, "marked": [0.07, 0.17, 0.7, 0.71], "step": 0.1, "label": "Alle getallen op de getallenlijn" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Kommagetallen ordenen", "content": "Maak alle getallen even lang achter de komma: 0,70 — 0,07 — 0,71 — 0,17. Vergelijk de honderdsten: 07, 17, 70, 71. Volgorde: 0,07 — 0,17 — 0,7 — 0,71.", "icon": "lightbulb" } }
      ],
      "conceptId": "komma_ordenen_interactive",
      "variantIndex": 6,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Maak alle getallen even lang: 0,70 — 0,07 — 0,71 — 0,17. Vergelijk de honderdsten: 07 < 17 < 70 < 71. Volgorde: 0,07 — 0,17 — 0,7 — 0,71.",
        "solutionSteps": [
          "Maak gelijk: 0,7 = 0,70; 0,07 = 0,07; 0,71 = 0,71; 0,17 = 0,17",
          "Vergelijk honderdsten: 07, 17, 70, 71",
          "Volgorde: 0,07 — 0,17 — 0,7 — 0,71"
        ]
      }
    }
  ]
}